var map = {
	"./de/texts.json": 28843,
	"./en/texts.json": 60573,
	"./es/texts.json": 60061,
	"./fr/texts.json": 22910,
	"./it/texts.json": 70328,
	"./nl/texts.json": 49441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34001;